import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { AxiosError } from 'axios';
import ApiContext from '../../contexts/ApiContext';
import { Issuer } from '../../../../../services/payment/PaymentV2Service';

export default function useGetMandateIssuersQuery(): UseQueryResult<Issuer[], AxiosError> {
  const { paymentsApi } = useContext(ApiContext);

  return useQuery({
    queryKey: ['getMandateIssuers'],
    queryFn: async () => {
      if (!paymentsApi) {
        throw new Error('paymentsApi is not available');
      }

      return paymentsApi.getMandateIssuers();
    },
  });
}
